import { render, staticRenderFns } from "./MatificButton.vue?vue&type=template&id=4b68d866"
import script from "./MatificButton.vue?vue&type=script&lang=js"
export * from "./MatificButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports